import React from 'react';

import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useLocation } from 'react-router-dom';

import { Header } from '../../components/Header';
import { Loader } from '../../components/Loader';
import { LEARNER_AL_ROUTE, MANAGER_AL_ROUTES } from '../../routes';
import { css } from '../../styled';
import { LARGE_MARGIN_PX, MIDDLE_MARGIN_PX } from '../../theme';
import { LearnerInfo } from '../../types';
import { Manager } from './components/Manager';
import { User } from './components/User';
import useStyles from './styles';

interface AssignedLearningPageProps {
  userInfo: LearnerInfo;
  title?: string;
  tenantTitle?: string | null;
  tenantName?: string | null;
}

const AssignedLearningPage: React.FC<AssignedLearningPageProps> = ({
  userInfo,
  title,
  tenantTitle,
  tenantName,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const location = useLocation();
  const isManagerDashboard = location?.pathname.includes(MANAGER_AL_ROUTES.List);

  const assignedTitle = title || t('page.assignedLearnings.assigned');

  return (
    <div>
      <Header
        title={`${assignedTitle} ${t('page.assignedLearnings.learning')}`}
        wrapperCss={headerWrapperCss}
        contentWrapperCss={headerContentWrapperCss}
        titleCss={headerTitleCss}
        tenantName={tenantName}
      >
        <Container>
          <Typography className={classes.headerDescription}>
            {t(
              isManagerDashboard
                ? 'page.assignedLearnings.learningManagerDesc'
                : 'page.assignedLearnings.learningLearnerDesc',
            )}
          </Typography>
        </Container>
      </Header>
      <Switch>
        {userInfo?.is_manager && (
          <Route
            path={MANAGER_AL_ROUTES.List}
            render={(props) => (
              <Manager tenantTitle={tenantTitle} fallback={<Loader />} {...props} />
            )}
          />
        )}
        <Route
          path={LEARNER_AL_ROUTE}
          render={(props) => (
            <User
              tenantTitle={tenantTitle}
              tenantName={tenantName}
              {...props}
              userId={userInfo?.id}
              isManager={userInfo?.is_manager}
              fallback={<Loader />}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default AssignedLearningPage;

const headerWrapperCss = css`
  margin-bottom: ${MIDDLE_MARGIN_PX};
`;

const headerContentWrapperCss = ({ theme }) => css`
  padding-top: 120px;
  padding-bottom: ${LARGE_MARGIN_PX};
  ${theme.breakpoints.up('md')} {
    padding-top: 200px;
  }
`;

const headerTitleCss = css`
  margin-bottom: 0;
  text-align: left;
`;
